/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type portfolio_CreateHandoverRequest = {
    childId: string;
    consentId?: string;
    effectiveDate: string;
    fromGroupId?: string;
    /**
     * HandoverType is pinned to the same two values as chk_ph_handover_type
     * (migration 137) and models.AllPortfolioHandoverTypes. All three move
     * together.
     */
    handoverType: portfolio_CreateHandoverRequest.handoverType;
    notes?: string;
    toGroupId?: string;
};
export namespace portfolio_CreateHandoverRequest {
    /**
     * HandoverType is pinned to the same two values as chk_ph_handover_type
     * (migration 137) and models.AllPortfolioHandoverTypes. All three move
     * together.
     */
    export enum handoverType {
        GROUP_CHANGE = 'group_change',
        DEPARTURE = 'departure',
    }
}

